import { Card, Collapse } from "antd";
import React, { useState } from "react";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";

export const CustomCard = ({
  loading,
  title,
  children,
  height = "auto",
  openDefault,
}) => {
  const [open, setOpen] = useState(false);

  const { isMobile } = useDeviceDetect();

  return (
    <>
      {isMobile ? (
        <Collapse
          key={title + "collapse"}
          className={"customCollapse"}
          defaultActiveKey={[openDefault ? title : null]}
          expandIconPosition={"end"}
          ghost={true}
        >
          <Collapse.Panel key={title} header={title} children={children} />
        </Collapse>
      ) : (
        <Card key={title} title={title} style={{ height }} loading={loading}>
          {children}
        </Card>
      )}
    </>
  );
};
